import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const LegalFooter = () => {
  const { t } = useTranslation();

  return (
    <div className="legal-footer">
      <Link to="/privacy">{t('legal.footerPrivacy')}</Link>
      {' · '}
      <Link to="/accessibility">{t('legal.footerAccessibility')}</Link>
    </div>
  );
};

export default LegalFooter;
